import _ from 'lodash';
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment-timezone';
//import moment from 'moment';

//- Material UI / Style
import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import { getGlobalClasses } from '../../themes';

//containers
import AuthUserContainer from '../../containers/AuthUser';

//- UI / Form
import Grid from '@material-ui/core/Grid';
//import SectionHeader from "../../components/SectionHeader";
//import CompanyDepartmentPicker from "../../components/advancedForm/CompanyDepartmentPicker";
//import DownloadIcon from '@material-ui/icons/CloudDownload';
import TmwApi from '../../containers/Ticket/TmwApi';
import { sampleUnbilledApiResult, sampleInvoiceResult } from './sampleTmwOrders';
import clsx from 'classnames';
import CircularProgress from '@material-ui/core/CircularProgress';
import LaunchIcon from '@material-ui/icons/Launch';
import FormSelect from '../../components/form/FormSelect';
import TmwInvoiceStatusSelect from '../../components/advancedForm/TmwInvoiceStatusSelect';
import localStorage from '../../libs/localStorage';

const MIN_DAYS_OUT = 0;
const MAX_DAYS_OUT = 7;
const NOW = moment();
//const MIN_MOMENT = moment().subtract(MIN_DAYS_OUT, 'days');
//const MAX_MOMENT = moment().subtract(MAX_DAYS_OUT, 'days');
const MIN_TO_MAX_DATES = _.range(MIN_DAYS_OUT, MAX_DAYS_OUT + 1).map((daysOut) => {
	const indexMoment = moment(NOW).subtract(daysOut, 'days');
	return {
		daysOut,
		dateMoment: indexMoment,
		dateKey: indexMoment.format('YYYY-MM-DD'),
		dateFormatted: indexMoment.format('ddd M/D'),
		isMax: daysOut === MAX_DAYS_OUT,
	};
});

/*
const MAX_TO_MIN_DATES = _.range(MAX_DAYS_OUT, MIN_DAYS_OUT - 1).map(daysOut => {
	const indexMoment = moment(NOW).subtract(daysOut, 'days');
	return {
		daysOut,
		dateMoment : indexMoment,
		dateKey : indexMoment.format('YYYY-MM-DD'),
		dateFormatted : indexMoment.format('ddd M/D'),
		isMax : (daysOut === MAX_DAYS_OUT),
	};
});
*/

const USE_TEST_DATA = false;

function rgba(rgb, a) {
	const { r, g, b } = rgb;
	return `rgba(${r},${g},${b},${a})`;
}

function rgb(r, g, b) {
	return { r, g, b };
}

const statusRowColors = [
	rgb(197, 202, 233),
	rgb(179, 229, 252),
	rgb(178, 223, 219),
	rgb(220, 237, 200),
	rgb(255, 236, 179),
	rgb(255, 204, 188),
	rgb(215, 204, 200),
	rgb(248, 187, 208),
];

const userRowColors = [
	rgb(232, 234, 246),
	rgb(225, 245, 254),
	rgb(224, 242, 241),
	rgb(241, 248, 233),
	rgb(255, 248, 225),
	rgb(251, 233, 231),
	rgb(239, 235, 233),
	rgb(252, 228, 236),
];

const styles = (theme) => {
	return {
		...getGlobalClasses(theme),
		oddCell: {
			backgroundColor: '#f9f9f9',
		},
		billToCompany: {
			fontWeight: 500,
			paddingRight: 7,
		},
		billTo: {
			color: '#444',
			fontWeight: 300,
			fontSize: '80%',
		},
		tableContainer: {
			width: '100%',
			tableLayout: 'auto',
			display: 'table',
			borderSpacing: 0,
			borderCollapse: 'collapse',
		},
		cell: {
			border: `1px solid #bbb`,
			overflowX: 'hidden',
			height: 'auto',
			position: 'relative',
			padding: `8px 10px`,
			textAlign: 'right',
		},
		cellHeader: {
			position: 'sticky',
			top: 0,
			zIndex: 101,
			boxShadow: '0 2px 2px -1px rgba(0, 0, 0, 0.4)',
			backgroundColor: '#EFEEEF',
			padding: `8px 10px`,
			fontWeight: 800,
			textTransform: 'uppercase',
			color: '#666',
			textAlign: 'right',
		},
		cellFooter: {
			backgroundColor: '#EFEEEF',
			padding: `7px 10px`,
			fontWeight: 800,
			textTransform: 'uppercase',
			color: '#666',
			textAlign: 'right',
			borderTop: '2px solid #aaa',
		},
		headerDate: {
			fontSize: '90%',
			fontWeight: '400',
		},
		statusCorner: {
			fontWeight: 600,
			textAlign: 'left',
		},
		userCorner: {
			fontWeight: 500,
			textAlign: 'left',
			paddingLeft: 20,
		},
		countLink: {
			textDecoration: 'none',
			fontWeight: 500,
			//color : '#1289D6',
			color: '#333',
		},
		countSpan: {
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'flex-end',
			alignContent: 'center',
			justifyItems: 'center',
			transition: '0.3s',
			'&:hover': {
				color: '#1289D6',
			},
		},
		countIcon: {
			fontSize: '100%',
			paddingLeft: 3,
			//color : '#1289D6',
		},
		totalCell: {
			borderLeft: '2px solid #67859e',
			fontWeight: 700,
			color: '#333',
		},
		totalRowCountValue: {
			fontWeight: 700,
		},
	};
};

function formatBillToCompany(billToCompany) {
	if (!billToCompany) {
		return 'Missing Company!';
	}

	let newCompanyName = billToCompany
		.toLowerCase()
		.split(' ')
		.map(function (i) {
			if (i.length > 2) {
				return i.charAt(0).toUpperCase() + i.substr(1);
			} else {
				return i.toUpperCase();
			}
		})
		.join(' ');
	newCompanyName = newCompanyName.replace('G & M', 'G&M');
	newCompanyName = newCompanyName.replace('Rtc', 'RTC');
	return newCompanyName;
}

function addDateRange(ref) {
	ref.countByDate = {};
	MIN_TO_MAX_DATES.forEach(({ dateKey, isMax }) => {
		ref.countByDate[dateKey] = {
			isMax,
			dateKey,
			count: 0,
		};
	});
}

function addTallyDateRange(ref) {
	ref.countByDate = {};
	MIN_TO_MAX_DATES.forEach(({ dateKey, isMax }) => {
		ref.countByDate[dateKey] = {
			isMax,
			dateKey,
			count: 0,
		};
	});
}

function makeUrl({ beforeDate, afterDate, invoiceStatus, lastUpdatedBy, billTo }) {
	let url = '/accounting/invoiceSearch';
	if (beforeDate) {
		url += `/${beforeDate}`;
	} else {
		return url;
	}
	if (afterDate) {
		url += `/${afterDate}`;
	} else {
		return url;
	}
	if (invoiceStatus) {
		url += `/${invoiceStatus}`;
	} else {
		return url;
	}
	if (lastUpdatedBy) {
		url += `/${lastUpdatedBy}`;
	} else {
		return url;
	}
	if (billTo) {
		url += `/${billTo}`;
	}
	return url;
}

function makeBillUrl({ beforeDate, afterDate, billTo }) {
	let url = '/accounting/unbilledOrders';
	if (beforeDate) {
		url += `/${beforeDate}`;
	} else {
		return url;
	}
	if (afterDate) {
		url += `/${afterDate}`;
	} else {
		return url;
	}
	if (billTo) {
		url += `/${billTo}`;
	}
	return url;
}

function getStorageKey(key) {
	return `/invoiceReport-${key}`;
}

class BillingReports extends Component {
	constructor(props) {
		super(props);

		let invoiceStatuses = localStorage.getItem(getStorageKey('invoiceStatuses')) || [];
		let unbilledReportType = localStorage.getItem(getStorageKey('unbilledReportType')) || 'tally';
		let invoiceReportType = localStorage.getItem(getStorageKey('invoiceReportType')) || 'tally';
		let invoiceBreakdownBy =
			localStorage.getItem(getStorageKey('invoiceBreakdownBy')) || 'byStatusBillerCustomer';

		this.state = {
			formFieldError: {},
			unbilledReportType,
			invoiceReportType,
			invoiceStatuses,
			invoiceBreakdownBy,
		};
	}

	componentDidMount() {
		if (USE_TEST_DATA) {
			this.setState(
				{
					unbilledApiResult: sampleUnbilledApiResult,
					invoiceApiResult: sampleInvoiceResult,
				},
				() => {
					this.formatUnbilledApiResult();
					this.formatInvoiceApiResult();
				}
			);
		} else {
			this.handleSearch();
		}
	}

	handleSearch = () => {
		const { searchUnbilledOrders, searchTmwInvoices, showErrors } = this.props;

		searchUnbilledOrders({
			params: {
				afterDateTime: moment().subtract(30, 'days').format('YYYY-MM-DD'),
				beforeDateTime: moment().add(1, 'day').format('YYYY-MM-DD'),
			},
			callback: (err, apiResult) => {
				if (err) {
					return showErrors(_.isArray(err) ? err : [err]);
				}

				this.setState({ unbilledApiResult: apiResult }, this.formatUnbilledApiResult);
			},
		});

		searchTmwInvoices({
			params: {
				afterDate: moment().subtract(30, 'days').format('YYYY-MM-DD'),
				beforeDate: moment().add(1, 'day').format('YYYY-MM-DD'),
			},
			callback: (err, apiResult) => {
				if (err) {
					return showErrors(_.isArray(err) ? err : [err]);
				}

				this.setState({ invoiceApiResult: apiResult }, this.formatInvoiceApiResult);
			},
		});
	};

	formatUnbilledApiResult = () => {
		const { unbilledReportType, unbilledApiResult } = this.state;
		if (!unbilledApiResult) {
			return;
		}

		const tmwOrders = _.get(unbilledApiResult, 'tmwOrders', []);
		const ordersByCustomerByDate = {};

		if (unbilledReportType === 'forecast') {
			tmwOrders.forEach((tmwOrder) => {
				const { tmwOrderId, billTo, billToCompany, completionDate } = tmwOrder;
				if (!tmwOrderId && !billToCompany) {
					console.error('Missing billToCompany', tmwOrder);
					return;
				}

				if (!ordersByCustomerByDate[billTo]) {
					ordersByCustomerByDate[billTo] = {
						billToCompany,
						billTo,
					};
					addDateRange(ordersByCustomerByDate[billTo]);
				}

				let countByDate = ordersByCustomerByDate[billTo].countByDate;
				const completionMoment = moment(completionDate);
				MIN_TO_MAX_DATES.forEach((dateRef) => {
					const { dateMoment, dateKey } = dateRef;
					if (completionMoment.isSameOrBefore(dateMoment, 'day')) {
						countByDate[dateKey].count++;
					}
				});
			});
		} else if (unbilledReportType === 'tally') {
			tmwOrders.forEach((tmwOrder) => {
				const { tmwOrderId, billTo, billToCompany, completionDate } = tmwOrder;
				if (!tmwOrderId && !billToCompany) {
					console.error('Missing billToCompany', tmwOrder);
					return;
				}

				if (!ordersByCustomerByDate[billTo]) {
					ordersByCustomerByDate[billTo] = {
						billToCompany,
						billTo,
					};
					addTallyDateRange(ordersByCustomerByDate[billTo]);
				}

				let countByDate = ordersByCustomerByDate[billTo].countByDate;
				const completionMoment = moment(completionDate);
				let foundDate = false;
				MIN_TO_MAX_DATES.forEach((dateRef) => {
					const { dateMoment, dateKey, isMax } = dateRef;

					if (isMax) {
						if (completionMoment.isSameOrBefore(dateMoment, 'day')) {
							countByDate[dateKey].count++;
							foundDate = true;
						}
					} else {
						if (completionMoment.isSame(dateMoment, 'day')) {
							countByDate[dateKey].count++;
							foundDate = true;
						}
					}
				});

				//- no match so put it in the 7+ days or future
				if (!foundDate) {
					console.error(`TMW ID ${tmwOrderId} with date of ${completionDate} not found in dates`);
				}
			});
		} else {
			console.error('unbilledReportType', unbilledReportType);
		}

		this.setState({
			ordersByCustomerByDate,
		});
	};

	formatInvoiceApiResult = () => {
		const { invoiceReportType, invoiceStatuses, invoiceApiResult } = this.state;
		if (!invoiceApiResult) {
			return;
		}

		const tmwInvoices = _.get(invoiceApiResult, 'tmwInvoices', []);
		const totalInvoiceBreakDown = {};
		//- By status, by last updated, by customer
		const invoiceBreakdown = {};

		if (invoiceReportType === 'forecast') {
			addDateRange(totalInvoiceBreakDown);
			tmwInvoices.forEach((tmwInvoice) => {
				const { billTo, billToCompany, completionDate, lastUpdatedBy, invoiceStatus } = tmwInvoice;

				if (!billToCompany) {
					console.log('MISSIN', tmwInvoice);
				}

				if (!_.isEmpty(invoiceStatuses) && !_.includes(invoiceStatuses, invoiceStatus)) {
					return;
				}

				let statusRef = invoiceBreakdown[invoiceStatus];
				if (!statusRef) {
					statusRef = invoiceBreakdown[invoiceStatus] = {
						invoiceStatus,
						byLastUpdatedBy: {},
						byCustomer: {},
					};
					addDateRange(statusRef);
				}

				let userRef = statusRef.byLastUpdatedBy[lastUpdatedBy];
				if (!userRef) {
					userRef = statusRef.byLastUpdatedBy[lastUpdatedBy] = {
						lastUpdatedBy,
						byCustomer: {},
					};
					addDateRange(userRef);
				}

				let customerRef = userRef.byCustomer[billTo];
				if (!customerRef) {
					customerRef = userRef.byCustomer[billTo] = {
						billTo,
						billToCompany,
					};
					addDateRange(customerRef);
				}

				//-Do it again in case they want a different breakdown
				let statusCustomerRef = statusRef.byCustomer[billTo];
				if (!statusCustomerRef) {
					statusCustomerRef = statusRef.byCustomer[billTo] = {
						billTo,
						billToCompany,
					};
					addDateRange(statusCustomerRef);
				}

				const completionMoment = moment(completionDate);
				MIN_TO_MAX_DATES.forEach((dateRef) => {
					const { dateMoment, dateKey } = dateRef;
					if (completionMoment.isSameOrBefore(dateMoment, 'day')) {
						totalInvoiceBreakDown.countByDate[dateKey].count++;
						statusRef.countByDate[dateKey].count++;
						userRef.countByDate[dateKey].count++;
						customerRef.countByDate[dateKey].count++;
						statusCustomerRef.countByDate[dateKey].count++;
					}
				});
			});
		} else if (invoiceReportType === 'tally') {
			addTallyDateRange(totalInvoiceBreakDown);
			tmwInvoices.forEach((tmwInvoice) => {
				const {
					billTo,
					billToCompany,
					completionDate,
					lastUpdatedBy,
					invoiceStatus,
					tmwOrderId,
				} = tmwInvoice;

				if (!_.isEmpty(invoiceStatuses) && !_.includes(invoiceStatuses, invoiceStatus)) {
					return;
				}

				let statusRef = invoiceBreakdown[invoiceStatus];
				if (!statusRef) {
					statusRef = invoiceBreakdown[invoiceStatus] = {
						invoiceStatus,
						byLastUpdatedBy: {},
						byCustomer: {},
					};
					addTallyDateRange(statusRef);
				}

				let userRef = statusRef.byLastUpdatedBy[lastUpdatedBy];
				if (!userRef) {
					userRef = statusRef.byLastUpdatedBy[lastUpdatedBy] = {
						lastUpdatedBy,
						byCustomer: {},
					};
					addTallyDateRange(userRef);
				}

				let customerRef = userRef.byCustomer[billTo];
				if (!customerRef) {
					customerRef = userRef.byCustomer[billTo] = {
						billTo,
						billToCompany,
					};
					addTallyDateRange(customerRef);
				}

				//-Do it again in case they want a different breakdown
				let statusCustomerRef = statusRef.byCustomer[billTo];
				if (!statusCustomerRef) {
					statusCustomerRef = statusRef.byCustomer[billTo] = {
						billTo,
						billToCompany,
					};
					addDateRange(statusCustomerRef);
				}

				const completionMoment = moment(completionDate);
				let foundDate = false;
				MIN_TO_MAX_DATES.forEach((dateRef) => {
					const { dateMoment, dateKey, isMax } = dateRef;

					if (isMax) {
						if (completionMoment.isSameOrBefore(dateMoment, 'day')) {
							totalInvoiceBreakDown.countByDate[dateKey].count++;
							statusRef.countByDate[dateKey].count++;
							userRef.countByDate[dateKey].count++;
							customerRef.countByDate[dateKey].count++;
							statusCustomerRef.countByDate[dateKey].count++;

							foundDate = true;
						}
					} else {
						if (completionMoment.isSame(dateMoment, 'day')) {
							totalInvoiceBreakDown.countByDate[dateKey].count++;
							statusRef.countByDate[dateKey].count++;
							userRef.countByDate[dateKey].count++;
							customerRef.countByDate[dateKey].count++;
							statusCustomerRef.countByDate[dateKey].count++;
							foundDate = true;
						}
					}
				});

				//- no match so put it in the 7+ days or future
				if (!foundDate) {
					console.error(`TMW ID ${tmwOrderId} with date of ${completionDate} not found in dates`);
				}
			});
		}

		this.setState({
			totalInvoiceBreakDown,
			invoiceBreakdown,
		});
	};

	//componentDidUpdate(prevProps, prevState, snapShot) {}

	//- Path is always a string
	//- value is never an event (value.target)
	onChange = (value, path, error) => {
		const arrayPath = _.toPath(path);
		const basePath = _.head(arrayPath);
		let base = this.state[basePath];
		let newState = {};

		if (_.isArray(base) || _.isObject(base)) {
			if (arrayPath.length > 1) {
				base = _.cloneDeep(base);
				_.set(base, arrayPath.slice(1), value);
				newState[basePath] = base;
			} else {
				newState[basePath] = value;
			}
		} else {
			newState[basePath] = value;
		}

		//- Clear any errors on the path
		let formFieldError = Object.assign({}, this.state.formFieldError);

		if (error) {
			formFieldError[path] = error;
		} else {
			delete formFieldError[path];
		}
		newState.formFieldError = formFieldError;

		if (
			path === 'invoiceStatuses' ||
			path === 'unbilledReportType' ||
			path === 'invoiceReportType' ||
			path === 'invoiceBreakdownBy'
		) {
			localStorage.setItem(getStorageKey(path), value);
		}

		if (
			path === 'invoiceStatuses' ||
			path === 'invoiceBreakdownBy' ||
			path === 'invoiceReportType'
		) {
			this.setState(newState, this.formatInvoiceApiResult);
		} else if (path === 'unbilledReportType') {
			this.setState(newState, this.formatUnbilledApiResult);
		} else {
			this.setState(newState);
		}
	};

	getInputProps = (path, defaultValue) => {
		return {
			key: path,
			path,
			value: this.getValue(path, defaultValue),
			checked: this.getValue(path, defaultValue),
			error: this.getError(path),
			onChange: this.onChange,
			gridProps: { md: 12 },
		};
	};

	getValue = (path, defaultValue) => {
		const _d = _.isUndefined(defaultValue) ? '' : defaultValue;
		return _.get(this.state, path, _d);
	};

	getError = (path) => {
		return _.get(this.state.formFieldError, path);
	};

	render() {
		return (
			<Fragment>
				{this.renderUnbilled()}
				{this.renderInvoices()}
			</Fragment>
		);
	}

	renderUnbilled = () => {
		const { classes } = this.props;
		const { ordersByCustomerByDate, unbilledReportType } = this.state;

		if (!ordersByCustomerByDate) {
			return (
				<Paper className={classes.globalMainPaper} style={{ minHeight: 500 }}>
					<CircularProgress style={{ verticalAlign: 'middle' }} />
					<span style={{ fontSize: 24, paddingLeft: 10 }}>Fetching TMW Unbilled Orders...</span>
				</Paper>
			);
		}

		const dateSort = unbilledReportType === 'tally' ? 'desc' : 'desc';
		const totalRows = {};
		let totalTotal = 0;
		return (
			<Paper className={classes.globalMainPaper} style={{ minHeight: 500 }}>
				<div className={classes.globalMainHeadline}>TMW Unbilled Orders Breakdown</div>
				<div style={{ fontWeight: 200, color: '#666' }}>* Stats are for last 30 days</div>

				<div style={{ margin: `20px 0px` }}>
					<Grid spacing={2} container>
						<FormSelect
							{...this.getInputProps('unbilledReportType')}
							label={'Report Type'}
							options={[
								{ value: 'tally', display: 'Tally by Date' },
								{ value: 'forecast', display: 'Forecast' },
							]}
							gridProps={{ md: 4 }}
						/>
					</Grid>
				</div>

				<Grid spacing={2} container>
					<Grid item xs={12} sm={11} md={12} lg={12}>
						<table className={classes.tableContainer}>
							{unbilledReportType === 'forecast' && this.renderForecastHeader()}
							{unbilledReportType === 'tally' && this.renderTallyHeader()}

							<tbody>
								{_.sortBy(_.values(ordersByCustomerByDate), 'billToCompany').map(
									(companyRow, i) => {
										const { billTo, billToCompany, countByDate } = companyRow;
										if (!billToCompany) {
											console.log('MISSING', companyRow);
										}

										const rowClass = i % 2 ? classes.oddCell : null;
										let totalRowCount = 0;

										return (
											<tr key={billTo}>
												<td className={clsx(classes.cell, rowClass)}>
													<span className={classes.billToCompany}>
														{formatBillToCompany(billToCompany)}
													</span>
													<span className={classes.billTo}>({billTo})</span>
												</td>
												{_.orderBy(_.values(countByDate), ['dateKey'], dateSort).map(
													(dateCount) => {
														const { dateKey, count, isMax } = dateCount;

														if (!totalRows[dateKey]) {
															totalRows[dateKey] = { dateKey, count: 0 };
														}
														totalRows[dateKey].count += count;
														totalRowCount += count;

														return this.renderUnbilledCell({
															billTo,
															dateKey,
															isMax,
															count,
															classes,
															rowClasses: [classes.cell, rowClass],
														});
													}
												)}

												{unbilledReportType === 'tally' && (
													<td className={clsx(classes.cell, rowClass, classes.totalCell)}>
														<span className={classes.totalRowCountValue}>{totalRowCount}</span>
													</td>
												)}
											</tr>
										);
									}
								)}

								<tr>
									<td className={clsx(classes.cell, classes.cellFooter)}>Total</td>
									{_.orderBy(_.values(totalRows), ['dateKey'], dateSort).map((dateCount) => {
										const { dateKey, count } = dateCount;
										totalTotal += count ? count : 0;
										return (
											<td className={clsx(classes.cell, classes.cellFooter)} key={`td${dateKey}`}>
												{count ? count : '-'}
											</td>
										);
									})}
									{unbilledReportType === 'tally' && (
										<td className={clsx(classes.cell, classes.cellFooter, classes.totalCell)}>
											{totalTotal}
										</td>
									)}
								</tr>
							</tbody>
						</table>
					</Grid>
				</Grid>
			</Paper>
		);
	};

	renderUnbilledCell = ({ billTo, dateKey, isMax, count, rowClasses, classes }) => {
		const { unbilledReportType } = this.state;

		const beforeDate = dateKey;
		let afterDate = dateKey;
		if (isMax || unbilledReportType === 'forecast') {
			afterDate = moment().subtract(30, 'days').format('YYYY-MM-DD');
		}

		const linkUrl = makeBillUrl({ billTo, beforeDate, afterDate });
		let content = count ? (
			<span className={classes.countSpan}>
				{count} <LaunchIcon className={classes.countIcon} />
			</span>
		) : (
			'-'
		);
		return (
			<td className={clsx(rowClasses)} key={`td${dateKey}`}>
				<a href={linkUrl} className={classes.countLink}>
					{content}
				</a>
			</td>
		);
	};

	renderInvoices = () => {
		const { classes } = this.props;
		const { invoiceBreakdown, totalInvoiceBreakDown, invoiceReportType } = this.state;

		const dateSort = invoiceReportType === 'tally' ? 'desc' : 'desc';

		if (!invoiceBreakdown) {
			return (
				<Paper className={classes.globalMainPaper} style={{ minHeight: 500 }}>
					<CircularProgress style={{ verticalAlign: 'middle' }} />
					<span style={{ fontSize: 24, paddingLeft: 10 }}>Fetching TMW Invoices...</span>
				</Paper>
			);
		}

		let totalTotal = 0;
		return (
			<Paper className={classes.globalMainPaper} style={{ minHeight: 500 }}>
				<div className={classes.globalMainHeadline}>TMW Invoices Breakdown </div>
				<div style={{ fontWeight: 200, color: '#666' }}>* Stats are for last 30 days</div>

				<div style={{ margin: `20px 0px` }}>
					<Grid spacing={2} container>
						<Grid item md={6}>
							<Grid spacing={2} container>
								<FormSelect
									{...this.getInputProps('invoiceReportType')}
									label={'Report Type'}
									options={[
										{ value: 'tally', display: 'Tally by Date' },
										{ value: 'forecast', display: 'Forecast' },
									]}
								/>

								<FormSelect
									{...this.getInputProps('invoiceBreakdownBy')}
									label={'Breakdown By'}
									options={[
										{ value: 'byStatusBillerCustomer', display: 'Status / Biller / Customer' },
										{ value: 'byStatusCustomer', display: 'Status / Customer' },
									]}
								/>

								<TmwInvoiceStatusSelect
									{...this.getInputProps('invoiceStatuses')}
									label={'Invoice Statuses (leave empty for all)'}
								/>
							</Grid>
						</Grid>
					</Grid>
				</div>

				<Grid spacing={2} container>
					<Grid item xs={12} sm={11} md={12} lg={12}>
						<table className={classes.tableContainer}>
							{invoiceReportType === 'forecast' && this.renderForecastHeader()}
							{invoiceReportType === 'tally' && this.renderTallyHeader()}
							<tbody>
								{this.renderInvoiceStatus()}
								<tr>
									<td className={clsx(classes.cell, classes.cellFooter)}>Total</td>
									{_.orderBy(
										_.values(totalInvoiceBreakDown.countByDate),
										['dateKey'],
										dateSort
									).map((dateCount) => {
										const { dateKey, count } = dateCount;
										totalTotal += count ? count : 0;
										return (
											<td className={clsx(classes.cell, classes.cellFooter)} key={`td${dateKey}`}>
												{count ? count : '-'}
											</td>
										);
									})}

									{invoiceReportType === 'tally' && (
										<td className={clsx(classes.cell, classes.cellFooter, classes.totalCell)}>
											{totalTotal}
										</td>
									)}
								</tr>
							</tbody>
						</table>
					</Grid>
				</Grid>
			</Paper>
		);
	};

	renderForecastHeader = () => {
		const { classes } = this.props;
		return (
			<thead>
				<tr>
					<th className={clsx(classes.cell, classes.cellHeader)}>Customer</th>
					{MIN_TO_MAX_DATES.map(({ daysOut, dateFormatted }) => {
						let daysOutDisplay = `${daysOut}+ days`;
						if (daysOut === 0) {
							daysOutDisplay = 'Today+';
						}

						return (
							<th className={clsx(classes.cell, classes.cellHeader)} key={`th${daysOut}`}>
								<div>{daysOutDisplay}</div>
								<div className={classes.headerDate}>{dateFormatted}</div>
							</th>
						);
					})}
				</tr>
			</thead>
		);
	};

	renderTallyHeader = () => {
		const { classes } = this.props;
		return (
			<thead>
				<tr>
					<th className={clsx(classes.cell, classes.cellHeader)}>Customer</th>
					{MIN_TO_MAX_DATES.map(({ daysOut, dateFormatted, isMax }) => {
						let daysOutDisplay = `${daysOut} days`;
						if (daysOut === 0) {
							daysOutDisplay = 'Today';
						} else if (daysOut === 1) {
							daysOutDisplay = 'Yesterday';
						} else if (isMax) {
							daysOutDisplay = `${daysOut}+ days`;
						}

						return (
							<th className={clsx(classes.cell, classes.cellHeader)} key={`th${daysOut}`}>
								<div>{dateFormatted}</div>
								<div className={classes.headerDate}>{daysOutDisplay}</div>
							</th>
						);
					})}

					<th className={clsx(classes.cell, classes.cellHeader, classes.totalCell)}>Total</th>
				</tr>
			</thead>
		);
	};

	renderInvoiceStatus = () => {
		const { classes } = this.props;
		const { invoiceBreakdown, invoiceBreakdownBy } = this.state;

		let currentGroupIndex = 0;
		return (
			<Fragment>
				{_.sortBy(_.values(invoiceBreakdown), 'invoiceStatus').map((statusRow) => {
					const colorIndex = currentGroupIndex % statusRowColors.length;
					const color = statusRowColors[colorIndex];
					const style = { background: rgba(color, 0.6) };
					currentGroupIndex++;
					const { invoiceStatus, countByDate } = statusRow;
					return (
						<Fragment key={invoiceStatus}>
							<tr>
								<td className={clsx(classes.cell, classes.statusCorner)} style={style}>
									{invoiceStatus}
								</td>
								{this.renderDayRows({ countByDate, style, invoiceStatus })}
							</tr>

							{invoiceBreakdownBy === 'byStatusBillerCustomer' &&
								this.renderInvoiceByStatusBillerCustomer({ invoiceStatus, statusRow, colorIndex })}
							{invoiceBreakdownBy === 'byStatusCustomer' &&
								this.renderInvoiceByStatusCustomer({ invoiceStatus, statusRow, colorIndex })}
						</Fragment>
					);
				})}
			</Fragment>
		);
	};

	renderInvoiceByStatusBillerCustomer = ({ invoiceStatus, statusRow, colorIndex }) => {
		const { classes } = this.props;

		return _.sortBy(_.values(statusRow.byLastUpdatedBy), 'lastUpdatedBy').map((userRow) => {
			const color = userRowColors[colorIndex];
			const style = { background: rgba(color, 0.6) };

			const { lastUpdatedBy, countByDate } = userRow;
			return (
				<Fragment key={lastUpdatedBy}>
					<tr>
						<td className={clsx(classes.cell, classes.userCorner)} style={style}>
							{lastUpdatedBy}
						</td>
						{this.renderDayRows({ countByDate, style, invoiceStatus, lastUpdatedBy })}
					</tr>

					{_.sortBy(_.values(userRow.byCustomer), 'billToCompany').map((companyRow, i) => {
						const { billToCompany, billTo, countByDate } = companyRow;
						const rowClass = i % 2 ? classes.oddCell : null;
						return (
							<tr key={billTo}>
								<td className={clsx(classes.cell, rowClass)}>
									<span className={classes.billToCompany}>
										{formatBillToCompany(billToCompany)}
									</span>
									<span className={classes.billTo}>({billTo})</span>
								</td>
								{this.renderDayRows({ countByDate, invoiceStatus, lastUpdatedBy, billTo })}
							</tr>
						);
					})}
				</Fragment>
			);
		});
	};

	renderInvoiceByStatusCustomer = ({ invoiceStatus, statusRow }) => {
		const { classes } = this.props;

		return _.sortBy(_.values(statusRow.byCustomer), 'billToCompany').map((companyRow, i) => {
			const { billToCompany, billTo, countByDate } = companyRow;
			const rowClass = i % 2 ? classes.oddCell : null;
			return (
				<tr key={billTo}>
					<td className={clsx(classes.cell, rowClass)}>
						<span className={classes.billToCompany}>{formatBillToCompany(billToCompany)}</span>
						<span className={classes.billTo}>({billTo})</span>
					</td>
					{this.renderDayRows({ countByDate, invoiceStatus, billTo })}
				</tr>
			);
		});
	};

	renderDayRows = ({ countByDate, style = {}, invoiceStatus, lastUpdatedBy, billTo }) => {
		const { invoiceReportType } = this.state;
		const { classes } = this.props;

		const dateSort = invoiceReportType === 'tally' ? 'desc' : 'desc';
		let totalRowCount = 0;
		return (
			<Fragment>
				{_.orderBy(_.values(countByDate), ['dateKey'], dateSort).map((dateCount) => {
					const { dateKey, count, isMax } = dateCount;
					totalRowCount += count;

					const beforeDate = dateKey;
					let afterDate = dateKey;
					if (isMax || invoiceReportType === 'forecast') {
						afterDate = moment().subtract(30, 'days').format('YYYY-MM-DD');
					}

					const linkUrl = makeUrl({ beforeDate, afterDate, invoiceStatus, lastUpdatedBy, billTo });

					let content = count ? (
						<span className={classes.countSpan}>
							{count} <LaunchIcon className={classes.countIcon} />
						</span>
					) : (
						'-'
					);

					return (
						<td className={clsx(classes.cell)} key={`td${dateKey}`} style={style}>
							<a href={linkUrl} className={classes.countLink}>
								{content}
							</a>
						</td>
					);
				})}

				{invoiceReportType === 'tally' && (
					<td className={clsx(classes.cell, classes.totalCell)} style={style}>
						<span className={classes.totalRowCountValue}>{totalRowCount}</span>
					</td>
				)}
			</Fragment>
		);
	};
}

BillingReports.propTypes = {
	searchUnbilledOrders: PropTypes.func.isRequired,
	searchTmwInvoices: PropTypes.func.isRequired,
	//userMap : PropTypes.object,

	showErrors: PropTypes.func.isRequired,
	authUser: PropTypes.object,
	classes: PropTypes.object.isRequired,
};

export default _.flow([withStyles(styles), AuthUserContainer, TmwApi])(BillingReports);
